import React from "react";
import '../../assets/css/style.css';


function Abutus() {
  


  return (

    <>
   <div className="mohtava-mine" >

<div className="dive-about-done" >
<p className="gift-stap-p-1" >درباره ما</p>

<p  className="text-center" >با استفاده از پلتفرم دان خریدهای روزمره خود را از فروشگاه های منتخب انجام داده، اعتبار خود را به صورت نقدی در کیف پول خود ذخیره کرده و در هر زمان آن را به حساب بانکی خود انتقال دهید!
</p>

<p  className="text-center" >
    این پایان مسیر نیست، خرید کنید و بلیط کنسرت خود و اعضای خانواده را مهمان دان باشید!
</p>
</div>

    </div>
      </>
   
  );
}

export default Abutus;
